/* eslint-disable */
import Antd, { Spin } from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import Vue from "vue";
import "./modal.css";
// import "ant-design-vue/dist/reset.css";
import BootstrapVue from "bootstrap-vue";
import Vbclass from "vue-body-class";
import VueFormWizard from "vue-form-wizard";
import VueGoodTablePlugin from "vue-good-table";
import VueMasonry from "vue-masonry-css";
import vSelect from "vue-select";
import Vuebar from "vuebar";
// import DatePicker from "vue-md-date-picker";
import { abilitiesPlugin, Can } from "@casl/vue";
import ability from "./ability";
// import Datetime from 'vue-datetime'
import VueNotifications from "vue-notifications";
import VueRouterBackButton from "vue-router-back-button";
import * as VueGoogleMaps from "vue2-google-maps";

import CKEditor from "@ckeditor/ckeditor5-vue";
import Noty from "noty";
import VeeValidate from "vee-validate";
import DrawerLayout from "vue-drawer-layout";
// import VueNativeSock from "vue-native-websocket";
// import VueWebsocket from "vue-websocket";
import OtpInput from "@bachdgvn/vue-otp-input";
import VuikitIcons from "@vuikit/icons";
import VModal from "vue-js-modal";

Vue.use(VuikitIcons);
Vue.use(Spin);
Vue.use(Antd);
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });

Vue.use(CKEditor);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAbz4NWK8NfeybeMGfBqQyablVMv2Xm0Lw",

    libraries: "places, drawing", // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },

  //// If you intend to programmatically custom event listener code
  //// (e.g. `this.$refs.gmap.$on('zoom_changed', someFunc)`)
  //// instead of going through Vue templates (e.g. `<GmapMap @zoom_changed="someFunc">`)
  //// you might need to turn this on.
  // autobindAllEvents: false,

  //// If you want to manually install components, e.g.
  //// import {GmapMarker} from 'vue2-google-maps/src/components/marker'
  //// Vue.component('GmapMarker', GmapMarker)
  //// then disable the following:
  // installComponents: true,
});

import locale from "element-ui/lib/locale";
import lang from "element-ui/lib/locale/lang/en";
// configure language
locale.use(lang);

function toast({ title, message, type, timeout, cb }) {
  if (type === VueNotifications.types.warn) type = "warning";
  return new Noty({
    theme: "bootstrap-v3",
    text: message,
    timeout,
    type,
  }).show();
}

const mercId = "09554"; //09554
const currCode = "566";

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
};

import App from "./App";
import router from "./router";
import store from "./store";
import UtilConstants from "./utils/constants";
import HttpUtils from "./utils/http-common";
import customLocalStorage from "./utils/localstorage-common";

// import "./utils/richmarker.js";
// import "flatpickr/dist/themes/material_blue.css";
import "@vuikit/theme";
import "vue-good-table/dist/vue-good-table.css";
import "../node_modules/bootstrap-vue/dist/bootstrap-vue.css";
import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "../node_modules/noty/lib/noty.css";
import "../node_modules/noty/lib/themes/bootstrap-v3.css";
import "../node_modules/vue-form-wizard/dist/vue-form-wizard.min.css";
// import 'vue-datetime/dist/vue-datetime.css'
import VueGtag from "vue-gtag";
import InfiniteLoading from "vue-infinite-loading";
import LineChart from "./components/pages/customerDashboard/LineChart.vue";
import ArnergyTable from "./components/pages/kitchen/arnergy-table";
import Center from "./components/pages/kitchen/center";
import GreyPagination from "./components/pages/kitchen/grey-pagination.vue";
import TableHeader from "./components/pages/kitchen/grey-table-header";
import GlobalMixin from "./mixins/global";

const isProduction = window.location.hostname === "solarbase.arnergy.com";

if (isProduction) {
  Vue.use(VueGtag, {
    config: { id: "AW-481803421" },
    bootstrap: false,
    onReady: () => {
      console.log("Google Analytics is ready");
    },
  });

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtag/js?id=AW-481803421";
  document.head.appendChild(script);

  script.onload = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      dataLayer.push(arguments);
    }
    gtag("js", new Date());
    gtag("config", "AW-481803421");
  };
}

Vue.mixin(GlobalMixin);
Vue.use(BootstrapVue);
Vue.use(Vbclass, router);
Vue.use(VueGoodTablePlugin);
Vue.use(VueFormWizard);
Vue.use(VueMasonry);
Vue.use(VueNotifications, options); //Notifications
// Vue.use(Notifications); //
Vue.use(Vuebar);
Vue.use(VeeValidate);
Vue.use(DrawerLayout);

Vue.use(VueRouterBackButton, { router });

import moment from "moment";

Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("YYYY-MM-DD");
  }
});
Vue.filter("formatDate", function (value) {
  if (value) {
    return moment(String(value)).format("YYYY-MM-DD");
  }
});
Vue.filter("formatDateTime", function (value) {
  if (value) {
    return moment(String(value)).format("YYYY-MM-DD  hh:mm:ss");
  }
});

Vue.component("arnergy-table", ArnergyTable);
Vue.component("grey-pagination", GreyPagination);
Vue.component("v-select", vSelect);
Vue.component("Can", Can);
Vue.component("table-header", TableHeader);
Vue.component("Center", Center);
Vue.component("line-chart", LineChart);
Vue.component("v-otp-input", OtpInput);
Vue.use(InfiniteLoading, {
  /* options */
});

router.beforeEach((to, from, next) => {
  // console.log(from.path)
  // localStorage.setItem('PATHMONITOR',from.name||"Home");
  // localStorage.setItem('PATHPARAMS',JSON.stringify(from.params));
  let isReload = false;
  if (window.performance) {
    // console.info(window.performance.navigation.type);
  }

  // do something based on the navigation type...
  switch (window.performance.navigation.type) {
    case 0:
      // console.info("TYPE_NAVIGATE");
      break;
    case 1:
      // console.info("TYPE_RELOAD");
      isReload = true;
      // if(from.name !== null){
      //   // next(from.name)
      //   console.log(from.fullPath)
      // }
      // next(from.path)
      //  next({ name: from.name||"Home", params: from.params });
      break;
    case 2:
      // console.info("TYPE_BACK_FORWARD");
      break;
    case 255:
      // console.info("255");
      break;
  }

  const HTTP = HttpUtils.FASTHTTP;
  const HTTP1 = HttpUtils.instance;
  const searchParams = new URLSearchParams(window.location.search);
  const jwt = searchParams.get("jwt_token");

  const token =
    store.getters.getUserSession !== null
      ? store.getters.getUserSession.token
      : jwt !== null
      ? jwt
      : null;

  async function fetchUserData() {
    try {
      const userResponse = await HTTP1.get(
        `/users/${
          store.getters.getUserSession.id
        }/?filter[include][role_mappings]/?${Date.now()}`
      );
      if (userResponse.status === 200) {
        const userData = userResponse.data;
        userData.token = token;
        userData.roleType = [{ subject: userData.roleType, actions: "all" }];
        setAccessLocal(userData);
        HTTP1.defaults.headers.common["Authorization"] = token;
      }
    } catch (error) {
      await refreshUserToken();
    }
  }

  async function refreshUserToken() {
    try {
      const userResponse = await HTTP.get("/auth/user", {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("appUserToken")}`,
        },
      });
      if (userResponse.status === 200) {
        const userData = userResponse.data;
        userData.token = token;
        userData.roleType = [{ subject: userData.roleType, actions: "all" }];
        setAccessLocal(userData);
        HTTP.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      } else {
        // logout();
      }
    } catch (error) {
      console.error("Failed to refresh user token:", error);
      // logout();
    }
  }

  if (token !== null) {
    fetchUserData();
  } else {
    console.error("Token is null.");
  }

  function setAccessLocal(userSession) {
    store.commit("setUser", userSession);
    //ability.update(userSession.roleType);
  }

  const acl =
    store.getters.getUserSession !== null
      ? store.getters.getUserSession.roleType
      : null;
  //  token = (store.getters.getUserSession !== null) ?
  //   store.getters.getUserSession.token :
  //   null;
  if (to.path === "/home" || to.path === "/") {
    // console.log(to.path)
    store.commit("setHome", true);
  } else {
    store.commit("setHome", false);
  }

  if (token) {
    // let a = ability;
    next();
    // console.log(from.path);
    if (from.name !== null && isReload) {
      // next(from.fullPath)
    } else {
      // next();
    }
    // console.log(from, isReload)
  } else {
    if (to.path.indexOf("/auth") > -1) {
      next();
    } else {
      next("/auth/login");
    }
  }
  Vue.use(abilitiesPlugin, ability);
});

export const timeAgoUtil = function (time) {
  var templates = {
    prefix: "",
    suffix: " ago",
    seconds: "few seconds",
    minute: "about a minute",
    minutes: "%d minutes",
    hour: "about an hour",
    hours: "about %d hours",
    day: "a day",
    days: "%d days",
    month: "about a month",
    months: "%d months",
    year: "about a year",
    years: "%d years",
  };
  var template = function (t, n) {
    return templates[t] && templates[t].replace(/%d/i, Math.abs(Math.round(n)));
  };

  var timer = function (time) {
    if (!time) return;
    // time = time.replace(/\.\d+/, ""); // remove milliseconds
    // time = time.replace(/-/, "/").replace(/-/, "/");
    // time = time.replace(/T/, " ").replace(/Z/, " UTC");
    // time = time.replace(/([\+\-]\d\d)\:?(\d\d)/, " $1$2"); // -04:00 -> -0400
    // time = new Date(time * 1000 || time);

    var now = new Date();
    var seconds = (time * 0.001) >> 0;
    var minutes = seconds / 60;
    var hours = minutes / 60;
    var days = hours / 24;
    var years = days / 365;

    // console.log({
    //   seconds,
    //   minutes,
    //   hours,
    //   days,
    //   years
    // })

    return (
      templates.prefix +
      ((seconds < 45 && template("seconds", seconds)) ||
        (seconds < 90 && template("minute", 1)) ||
        (minutes < 45 && template("minutes", minutes)) ||
        (minutes < 90 && template("hour", 1)) ||
        (hours < 24 && template("hours", hours)) ||
        (hours < 42 && template("day", 1)) ||
        (days < 30 && template("days", days)) ||
        (days < 45 && template("month", 1)) ||
        (days < 365 && template("months", days / 30)) ||
        (years < 1.5 && template("year", 1)) ||
        template("years", years)) +
      templates.suffix
    );
  };

  return timer(time);
};

// To Disable logs
// console.log = function() {};
// console.log = function() {};

Vue.prototype.$httpUtils = HttpUtils;
Vue.prototype.$utilConstants = UtilConstants;
Vue.prototype.$customLocalStorage = customLocalStorage;
Vue.config.productionTip = false;
Vue.prototype.$log = console.log.bind(console);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js